import React from "react"
import PropTypes from "prop-types"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"

const AvailabilityPicker = ({
  disabled,
  id,
  invalid,
  name,
  onChange,
  type,
  value,
}) => {
  const isTime = type === "time"
  const options = isTime
    ? {
        allowInput: false,
        altFormat: "h:i K",
        altInput: true,
        altInputClass: `form-control${invalid ? " is-invalid" : ""}`,
        dateFormat: "H:i",
        enableTime: true,
        minuteIncrement: 1,
        noCalendar: true,
      }
    : {
        allowInput: false,
        altFormat: "d M Y",
        altInput: true,
        altInputClass: `form-control${invalid ? " is-invalid" : ""}`,
        dateFormat: "Y-m-d",
      }

  return (
    <Flatpickr
      className={`form-control${invalid ? " is-invalid" : ""}`}
      disabled={disabled}
      id={id}
      name={name}
      options={options}
      value={value || ""}
      onChange={(dates, dateString) =>
        onChange({ target: { name, value: dateString } })
      }
    />
  )
}

AvailabilityPicker.propTypes = {
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  invalid: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(["date", "time"]).isRequired,
  value: PropTypes.string,
}

export default AvailabilityPicker
